<div class="frame-in">
  <div class="items zone-5-frame">
    <div class="country zone-5">
    </div>
    <svg class="road zone-5">
      <path id="Shape 2233" class="shp0"
        d="M735 348C735 348 736 368.79 736 376C736 383.21 734.44 403 712 403C689.56 403 621.83 401.25 610 413C598.17 424.75 575.66 451 503 451C430.34 451 391 446 391 446" />
        <path id="Shape 1601" class="shp0" d="M332.91 444.29C332.91 444.29 229.02 502.26 171.95 399.64" />
        <path id="Shape 3937" class="shp0"
          d="M124.25 341.49C124.25 341.49 -21.65 329.01 3.71 261.6C18.76 221.62 114.45 229.37 140 229C171.42 228.55 253.28 239.3 291 236C328.72 232.7 362.28 221.59 359 185" />
          <path id="Shape 1585" class="shp0"
            d="M373 118C373 118 372.59 99 414 99C455.41 99 472.85 95.09 473 74C473.15 52.91 473 43.52 473 43.52C473 43.52 476.67 22.48 441 22.48C405.33 22.48 367.46 18.65 365 0.3" />
          </svg>

          @for (zone of zones; track zone) {
            <div class="country {{zone.class}}" [ngClass]="{'hover': zone.hover}">
            </div>
          }

          @for (zone of zones; track zone; let i = $index) {
            <div class="poi {{zone.class}}"
              (click)="selectZone(zone)" (mouseenter)="mouseEnter(i)" (mouseleave)="mouseLeave(i)"
              [ngClass]="{active: zone.active, 'lock': zone.locked}">
              <span>{{ zone.locked ? '' : zone.number}}</span>
            </div>
          }
          <div class="poi quiz" (click)="goQuiz()" [ngClass]="{'lock': quizLevel < 5, 'active': quizLevel === 5 && tick2Quiz}"></div>
        </div>
      </div>

      <img class="frame-title" src="assets/images/zones/5/title.png">

      <audio id="introductionAudio" (ended)="playBgAudio()">
        <source src="assets/sounds/country.wav" type="audio/wav">
      </audio>
      <audio id="bgAudio" (ended)="playIntroductionAudio()">
        <source src="assets/sounds/zone-b-g-sound.mp3" type="audio/mpeg">
      </audio>

      <div class="footer">
        <ul class="zone-menu">
          <li>
            @if (!haveAccess('2-1')) {
              <span class="lock"></span>
            }
            @if (haveAccess('2-1')) {
              <a class="menu-item" [routerLink]="[ '/game/zone5' ]" routerLinkActive="active">1</a>
            }
          </li>
          <li>
            @if (!haveAccess('2-2')) {
              <span class="lock"></span>
            }
            @if (haveAccess('2-2')) {
              <a class="menu-item" [routerLink]="[ '/game/zone6' ]" routerLinkActive="active">2</a>
            }
          </li>
          <li>
            @if (!haveAccess('2-3')) {
              <span class="lock"></span>
            }
            @if (haveAccess('2-3')) {
              <a class="menu-item" [routerLink]="[ '/game/zone7' ]" routerLinkActive="active">3</a>
            }
          </li>
        </ul>
        <img class="footer-bg" src="assets/images/zones/5/footer.png">
      </div>

      <audio id="continentHover">
        <source src="assets/sounds/continent_hover.mp3" type="audio/mpeg">
      </audio>
      <audio id="continentClick">
        <source src="assets/sounds/continent_selection.mp3" type="audio/mpeg">
      </audio>
